import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=e1ce4e64&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=e1ce4e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ce4e64",
  null
  
)

export default component.exports